module.exports = __webpack_public_path__ + "img/password.2b035478.svg";